// extracted by mini-css-extract-plugin
export var close = "bQ_F";
export var container = "bQ_b";
export var heading = "bQ_G";
export var linkContainer = "bQ_bt";
export var logoIcon = "bQ_bs";
export var section = "bQ_d";
export var show = "bQ_L";
export var title = "bQ_h";
export var value = "bQ_bv";